import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ROOT_ROUTE } from '../../constants';
import {
    setKeywordFilter,
    startFilteredLoad,
    openDropDown,
} from '../../redux/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import SearchIcon from './SearchIcon';

// width 368 with border
// height 60 with border
// icon - left padding 26
// icon - top padding 22
// font size 14
const SearchBar = (props: any) => {
    const { totalEvents } = props;
    const history = useHistory();
    const dispatch = useDispatch();
    let placeholder = 'Otsi...';
    if (totalEvents && totalEvents.total) {
        placeholder = `Otsi ${totalEvents.total} sündmuse hulgast`;
    }

    const [inputValue, setInputValue] = useState<string>("");

    const setValue = (st: string) => {
        if (st === '') {
            dispatch(setKeywordFilter(null));
        }
        setInputValue(st)
    }

    const startSearch = () => {
        if (!inputValue) {
            return false;
        }
        // console.log("SEARCH PUSH")
        history.push(ROOT_ROUTE || '/');
        dispatch(startFilteredLoad());
        dispatch(setKeywordFilter(`sw=${inputValue}`));
        dispatch(openDropDown(false));
    }
    const clearSearch = () => {
        setInputValue('');
        dispatch(setKeywordFilter(null));
    }
    return (
        <div className="search left-align">
            { inputValue &&
            <span onClick={clearSearch} className="icon-left">
                {inputValue}
            <FontAwesomeIcon
                icon={faTimesCircle as any}
                className='remove-filter'/>
            </span> }


            <input
                onChange={(
                    ev: React.ChangeEvent<HTMLInputElement>,
                ): void => { return setValue(ev.target.value)}}
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        startSearch()
                    }
                  }}
                type="text"
                value={inputValue}
                className="search-input"
                placeholder={placeholder}/>
                <span onClick={startSearch} className="icon">
                  <SearchIcon />
                </span>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    const { totalEvents } = state;
    return {totalEvents};
};

export default connect(
    mapStateToProps
  )(SearchBar);
